import {
  Box,
  TextField,
  FormControl,
  InputAdornment,
  InputLabel,
  Input,
  IconButton,
  Button,
  Typography,
  Select,
  MenuItem,
  FormHelperText,
  Alert,
  Divider,
} from "@mui/material";
import {
  AccountCircleOutlined,
  Visibility,
  VisibilityOff,
  LockOutlined,
  Group,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set } from "lodash";
import { Tabs } from "../../../components/tabs";
import { Grid } from "../../../components/table";
import { CONFIG } from "../../../../config";
import axios from "axios";
import { ToolBar } from "../../../components/toolbar";
import { Modal } from "../../../components/modal";
import { FormA } from "../../../components/form";
import moment from "moment";
import { getFormState } from "../../../../helpers/form";
import dayjs from "dayjs";
import { SelectA, FileUploadA, DatePickerA } from "../../../components/form";
import { AllocationUpload } from "../upload";
import { FollowUpList } from "../follow-up";
import { NewDataList } from "../new-data";
import { Today } from "../today";
import { Assigned } from "./assigned";
import { Pending } from "./pending";
import { LiveAllocation } from "../live-allocation";
import { SankalpList } from "../sankalp-data";
import { ECDList } from "../ecd-reports";
import { PreviouslyUnattempted } from "./previously-unattempted/previoulsy-unattempted-index";
const API_HOST = CONFIG.modules["accounts"].host;

const items = {
  Assigned: {
    name: "Assigned",
    view: (socket) => <Assigned socket={socket} />,
  },
  // Queue: {
  //   name: "Queue",
  //   view: (socket) => <Pending socket={socket} />,
  // },
  // "Previously Unattempted": {
  //     name: "Previously Unattempted",
  //     view: (socket) => <PreviouslyUnattempted socket={socket} />,
  // },
};

const markStyle = {
  borderRadius: 1,
  ml: 2,
  minWidth: 300,
  background: "#F3D55B",
  mb: 3,
  height: 40,
  pl: 2,
  display: "flex",
  alignItems: "center",
};

const wrap = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};
const text2 = { fontSize: ".8em" };
export const Allocations = (props) => {
  const {
    roles,
    user,
    users,
    Designations,
    Departments,
    Languages,
    Districts,
    Campaigns,
  } = useSelector((state) => state.user || {});
  const { state } = props.location;

  console.log(state, "props route");

  const [active, setActive] = useState("Assigned");

  return (
    <>
      <Tabs
        items={items}
        active={active}
        state={state}
        onChange={(key) => {
          setActive(key);
        }}
      />
      {items[active] &&
        items[active].view &&
        props.socket &&
        items[active].view(props.socket)}
    </>
  );
};
